module.exports = __webpack_public_path__ + "img/progress.f1e0d80b.jpg";